import { CONSENT_CATEGORIES, parseDataGrailCookie } from 'client-portal/utils/datagrail';
import Service, { service } from '@ember/service';

export default class ConsentManagerService extends Service {
  @service fastboot;

  _parentFramePreferences = null;

  setFromParent(rawValue) {
    this._parentFramePreferences = rawValue
      ? Object.fromEntries(
          rawValue.split('|').map(pair => {
            let [key, value] = pair.split(':');
            return [key, value === '1'];
          })
        )
      : null;
  }

  getConsentContext() {
    let cookiePrefs = this.fastboot?.isFastBoot
      ? null
      : (parseDataGrailCookie() ?? this._parentFramePreferences);
    return {
      consent: {
        categoryPreferences: CONSENT_CATEGORIES.reduce((acc, { dbKey, cookieKey }) => {
          acc[dbKey[0].toUpperCase() + dbKey.slice(1)] = cookiePrefs?.[cookieKey] ?? true;
          return acc;
        }, {}),
      },
    };
  }

  getConsentPreferences() {
    let {
      consent: { categoryPreferences },
    } = this.getConsentContext();
    return Object.fromEntries(
      Object.entries(categoryPreferences).map(([key, value]) => [key.toLowerCase(), value])
    );
  }
}
